import "react-quill/dist/quill.snow.css";
import "./RichText.css";

import React, { forwardRef, useImperativeHandle, useRef } from "react";
import ReactQuill from "react-quill";

import {
  normalizeRichTextLinkElement,
  normalizeRichTextLinks,
} from "../../utils/normalizeRichTextLinks";

type Props = {
  value: string;
  onChange: (val: string) => void;
  outerHeight?: number; // px
  toolbarHeight?: number; // px
  className?: string;
  placeholder?: string;
};

export type RichTextHandle = {
  insertText: (text: string) => void;
  getHtml: () => string;
};

const RichText = forwardRef<RichTextHandle, Props>(
  (
    {
      value,
      onChange,
      outerHeight = 200,
      toolbarHeight = 60,
      className = "",
      placeholder,
    },
    ref,
  ) => {
    const quillRef = useRef<any>(null);

    useImperativeHandle(ref, () => ({
      insertText: (text: string) => {
        const editor = quillRef.current?.getEditor?.();
        if (editor) {
          const range = editor.getSelection(true);
          const index = range ? range.index : editor.getLength();
          editor.insertText(index, text);
        }
      },
      getHtml: () => quillRef.current?.getEditor?.()?.root?.innerHTML || "",
    }));

    const handleChange = (html: string) => {
      onChange(normalizeRichTextLinks(html));
    };

    const handleClickCapture = (event: React.MouseEvent<HTMLDivElement>) => {
      const link = (event.target as HTMLElement).closest("a[href]");

      if (link instanceof HTMLAnchorElement) {
        normalizeRichTextLinkElement(link);
      }
    };

    return (
      <div
        className={`rich-text input input-bordered overflow-visible p-0 ${className}`}
        onClickCapture={handleClickCapture}
        style={{
          height: `${outerHeight}px`,
        }}>
        <ReactQuill
          ref={quillRef}
          theme={"snow"}
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
        />
      </div>
    );
  },
);

export default RichText;
